<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        indicatorClasses: {
            type: String,
            default: 'w-6 mx-auto'
        },
        colour: {
            type: String,
            default: '#f5f9fe'
        },
    }
}
</script>

<template>
    <div v-if="loading">
        <slot>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                :class="indicatorClasses"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
            >
                <g transform="rotate(0 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.95s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(18 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.9s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(36 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.85s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(54 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.8s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(72 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.75s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(90 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.7s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(108 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.65s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(126 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.6s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(144 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.55s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(162 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.5s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(180 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.45s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(198 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.4s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(216 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.35s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(234 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.3s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(252 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.25s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(270 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.2s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(288 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.15s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(306 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.1s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(324 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.05s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
                <g transform="rotate(342 50 50)">
                    <rect
                        x="47"
                        y="9"
                        rx="0.6"
                        ry="0.6"
                        width="6"
                        height="12"
                        :fill="colour"
                    >
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="0s"
                            repeatCount="indefinite"
                        />
                    </rect>
                </g>
            </svg>
        </slot>
    </div>
</template>
